// Module
var code = "<div class=\"team-content-deletion-notice\"> <div class=\"container\"> <i class=\"delete-all-content-notice-icon\"></i> <p data-ng-bind-html=\" 'BANNER_MESSAGE'|t | trusted\"> </p> <button class=\"banner-close implioicons-close\" aria-label=\"Close\" data-ng-click=\"vm.closeBanner()\"> </button> </div> </div> ";
// Exports
module.exports = code;